<template>
    <AppLayout>
        <div class="overflow-hidden sm:rounded">
            <div class="flex pt-5 pb-2">
                <h2 class="text-lg font-medium text-gray-900">
                    {{ $t("users.title") }}
                </h2>
                <span
                    class="text-sm cursor-pointer ml-auto mt-auto text-lightblue-700 hover:text-lightblue-500"
                    @click="showCreateModal = true"
                    >{{ $t("users.buttons.new") }}
                </span>
            </div>

            <div v-if="!hasUsers" class="max-w-7xl mx-auto">
                <div class="w-full m-auto justify-center items-center">
                    <div class="flex">
                        <fa-icon icon="users" class="mx-auto text-7xl text-gray-300"></fa-icon>
                    </div>
                    <h2 class="my-2 text-4xl text-gray-300 text-center">
                        {{ $t("users.forms.no_users_yet") }}
                    </h2>
                </div>
            </div>

            <div v-if="hasUsers" class="py-5 sm:p-0">
                <Table
                    :headers="['id', 'name', 'email', 'tenant', 'active', 'actions']"
                    :content="currentUsers"
                    :loading-items="currentlyProcessing"
                    @action-click="actionClickHandler"
                />
            </div>

            <user-create
                :show-modal="showCreateModal"
                :error-bags="errorBags"
                :tenants="tenants"
                :preselected-tenant="showCreateWithTenantId"
                @close-modal="showCreateModal = false"
            ></user-create>
        </div>

        <pagination
            class="mt-5"
            :previous-page-url="users.links.prev"
            :pages="users.meta.links"
            :next-page-url="users.links.next"
        ></pagination>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import FaIcon from "@/Components/FaIcon";
import Table from "@/Components/Table";
import { computed, ref } from "vue";
import { Inertia } from "@inertiajs/inertia";
import Pagination from "../../Components/Pagination";
import UserCreate from "./UserCreate";

export default {
    name: "Users",
    components: { UserCreate, Pagination, FaIcon, AppLayout, Table },
    props: {
        tenant: Object,
        tenants: Array,
        users: Array,
        errorBags: Object,
    },
    setup(props) {
        const showCreateWithTenantId = ref(new URLSearchParams(window.location.search).get("showCreateWithTenant"));
        const showCreateModal = ref(!!showCreateWithTenantId.value);
        const currentlyProcessing = ref([]);
        const hasUsers = computed(() => Boolean(props.users.data.length));
        const currentUsers = computed(() => {
            if (!props.users.data) {
                return [];
            }

            return props.users.data;
        });

        const actionClickHandler = (data) => {
            switch (data.action) {
                case "password-reset":
                    Inertia.post(
                        route(`universal.users.resetpassword`, {
                            user: currentUsers.value[data.index].id,
                        })
                    ).finally(() => {
                        const index = currentlyProcessing.value.findIndex(
                            (item) => item.index === data.index && item.action === data.action
                        );

                        if (index !== -1) {
                            currentlyProcessing.value.splice(index, 1);
                        }
                    });

                    break;
                case "activate":
                case "deactivate":
                    Inertia.delete(
                        route(`universal.users.destroy`, {
                            user: currentUsers.value[data.index].id,
                        })
                    ).finally(() => {
                        const index = currentlyProcessing.value.findIndex(
                            (item) => item.index === data.index && item.action === data.action
                        );

                        if (index !== -1) {
                            currentlyProcessing.value.splice(index, 1);
                        }
                    });

                    break;
                default:
                    return;
            }

            currentlyProcessing.value.push({
                index: data.index,
                action: data.action,
            });
        };

        return {
            showCreateModal,
            currentlyProcessing,
            hasUsers,
            currentUsers,
            showCreateWithTenantId,
            actionClickHandler,
        };
    },
};
</script>
